import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface LogoutIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const LogoutIcon: React.FC<LogoutIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-logout">
    <path
      d="M23.9917 6L6 6L6 42H24"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
    />
    <path d="M33 33L42 24L33 15"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
    />
    <path d="M16 23.9917H42"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default LogoutIcon;


